import React from 'react';
import InvestmentHistory from '../components/sections/InvestmentHistory';
import ActivityFeed from '../components/sections/ActivityFeed';

export default function History() {
  return (
    <div className="fade-in">
      <div className="page-header">
        <div>
          <h2 className="page-title"><span className="title-accent">≡</span> History</h2>
          <div className="page-subtitle">Investment ledger & full activity trail</div>
        </div>
      </div>

      <div className="mb-4">
        <InvestmentHistory />
      </div>

      <ActivityFeed />
    </div>
  );
}
